// extracted by mini-css-extract-plugin
var _1 = "styles_orderSummary__jM61o";
var _2 = "styles_row__p62k9";
export { _1 as "orderSummary", _2 as "row" }
